import isBrowser from './isBrowser';

const publicPaths = ['login'];

const currentPath = isBrowser() ? window.location.href : '';
const isPublicPage = !!publicPaths.find((publicPath: string) => currentPath.includes(publicPath));

export { isPublicPage };
